import { render, staticRenderFns } from "./kendo-multiselect.vue?vue&type=template&id=3d8bae66&scoped=true"
import script from "./kendo-multiselect.vue?vue&type=script&lang=js"
export * from "./kendo-multiselect.vue?vue&type=script&lang=js"
import style0 from "./kendo-multiselect.vue?vue&type=style&index=0&id=3d8bae66&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d8bae66",
  null
  
)

export default component.exports